import './ReferralEdit.scss'
import './Referral.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'
import { getFirstAndLastName } from 'common/util/helper'
import { scrollToTop } from 'manager/util/helper'

import {
    updateContact
} from 'manager/redux/referral'


class ReferralEditContact extends Component {

  constructor(props) {
    super(props)

    const {
      referral: {
        name,
        email,
      }
    } = props

    const nameParts = getFirstAndLastName(name)
    let first_name = '', last_name = ''
    if (nameParts.last_name && !nameParts.last_name.match('Declined last name')) {
      first_name = nameParts.first_name
      last_name = nameParts.last_name
    } else {
      first_name = nameParts.first_name
    }

    this.state = {
      first_name,
      last_name,
      email,
      disabled: !first_name
    }
  }

  handleClick = async () => {
    const { dispatch, params } = this.props
    const { disabled } = this.state
    if (!disabled) {
      dispatch(updateContact(params.hash, this.state))
    }
    this.setState({disabled: true})
  }

  handleFieldChange = (field, value) => {
    this.setState({[field]: value}, this.updateDisabled)
  }

  handleOnBlur = (field, value)  => {
    // Trim whitespace only when clicking/tapping outside of input field.
    const trimmedValue  = value.trim()
    this.setState({[field]: trimmedValue}, this.updateDisabled)
  }

  updateDisabled = () => {
    const { first_name, email } = this.state
    const trimmedFirstName = first_name.trim()
    // Only trimming whitespace for first_name.
    // Whitespace trimming for email already handled by <input type"email">.
    this.setState({ disabled: !(trimmedFirstName && (email ? this.validateEmail(email) : true)) })
  }

  validateEmail = (email) => {
    /*
      This regex, for email validation, was grabbed from https://emailregex.com.
      It originally escapes open-square-brace, like so '\[' ....but stickler-ci complains with:
          " Unnecessary escape character: \[. (no-useless-escape) "
      Not escaping open square brace works as we would like (ie, inputing '[' in
      the email field will disable the 'Save' button); therefore,
      open-square-brace is not escaped in this regex.
    */
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLocaleLowerCase())
  }

  render() {
    const { first_name, last_name, email, disabled } = this.state

    return (
      <div className="ReferralTransaction">

        <div className="ReferralTransaction__row">
          <div
            className="ReferralTransaction__label">First Name <span className="ReferralTransaction__required">*</span></div>
          <input
            className="ReferralTransaction__input"
            type="text"
            value={first_name}
            placeholder="First Name"
            onChange={(e) => (this.handleFieldChange('first_name', e.target.value))}
            onBlur={(e) => (this.handleOnBlur('first_name', e.target.value))}
            onFocus={scrollToTop}
          />
        </div>

        <div className="ReferralTransaction__row">
          <div className="ReferralTransaction__label">Last Name</div>
          <input
            className="ReferralTransaction__input"
            type="text"
            value={last_name}
            placeholder="Last Name"
            onChange={(e) => (this.handleFieldChange('last_name', e.target.value))}
            onBlur={(e) => (this.handleOnBlur('last_name', e.target.value))}
            onFocus={scrollToTop}
          />
        </div>

        <div className="ReferralTransaction__row">
          <div className="ReferralTransaction__label">Email</div>
          <input
            className="ReferralTransaction__input"
            type="email"
            value={email}
            placeholder="Email"
            onChange={(e) => (this.handleFieldChange('email', e.target.value))}
            onFocus={scrollToTop}
          />
        </div>

        <div className="ReferralTransaction__footer">
          <Button
            disabled={disabled}
            onClick={this.handleClick}
            bsStyle="success">Save</Button>
        </div>

      </div>
    )
  }

}

export default ReferralEditContact
